import { render, staticRenderFns } from "./SearchEventsDialog.vue?vue&type=template&id=4cfa3a27&scoped=true"
import script from "./SearchEventsDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchEventsDialog.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SearchEventsDialog.vue?vue&type=style&index=0&id=4cfa3a27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfa3a27",
  null
  
)

export default component.exports